import React, { Component, Fragment } from "react";
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  FormControl,
} from "@material-ui/core";
import {
  extractCheckBoxValue,
  extractCheckBoxIndices,
  extractAiFlags,
} from "../../store/form.answer.extract";
import { checkBoxAnswer } from "../../store/form.answer.fill";
import { openSectionState, currentSectionState } from "../../store/form.store";
import { AiStatusOverlay } from "../../../components/AiStatusOverlay";

export class CheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: [],
      selectedOptionIndices: [],
      // helpTextValue: "",
      imageValue: [],
      editable: false,
      aiFlags: {},
    };
  }

  componentDidMount() {
    let expanded = "";
    this.sectionStateSubscription = openSectionState.subscribe((sectionId) => {
      expanded = sectionId;
    });
    this.currentSectionSubscription = currentSectionState.subscribe(
      (section) => {
        this.setState({ editable: section === expanded });
      },
    );
    this.onLoadPage(this.props);
    // if (this.props.element.properties.answerLabel) {
    //   this.onLoadHelpText(this.props);
    // }
    if (this.props.element.properties.allowFileUpload) {
      this.onLoadImage(this.props);
    }
  }

  componentWillUnmount() {
    this.sectionStateSubscription.unsubscribe();
    this.currentSectionSubscription.unsubscribe();
  }

  onLoadPage(props) {
    if (props.element) {
      let answer = props.element.answer;
      let userResponse = extractCheckBoxValue(answer);
      let selectedIndices = extractCheckBoxIndices(
        answer,
        props.element.options,
      );
      if (userResponse) {
        this.setState({
          selectedOptions: userResponse,
          selectedOptionIndices: selectedIndices,
        });
      }
    }
  }

  // onLoadHelpText(props) {
  //   const answerLabel = props.element.properties.answerLabel;
  //   if (answerLabel) {
  //     this.setState({ helpTextValue: answerLabel });
  //   }
  // }

  onLoadImage(props) {
    if (
      props.element &&
      props.element.answer &&
      props.element.answer.length > 0
    ) {
      const image = props.element.answer[0].images;
      if (image) {
        this.setState({ imageValue: image });
      }
      this.setState({ aiFlags: extractAiFlags(props.element.answer) });
    }
  }

  onChange = (option, selectedOptionIndex) => {
    let options = this.state.selectedOptions;
    let selectedIndices = this.state.selectedOptionIndices;
    let index = options.indexOf(option);
    if (!selectedIndices.includes(selectedOptionIndex)) {
      options.push(option);
      selectedIndices.push(selectedOptionIndex);
    } else {
      options.splice(index, 1);
      selectedIndices.splice(selectedIndices.indexOf(selectedOptionIndex), 1);
    }

    this.setState({ selectedOptions: options }, () => {
      if (this.props.onChange !== undefined) {
        this.props.onChange(
          checkBoxAnswer(options, this.props?.element?.answer),
          this.props.element
        );
      }
    });
  };

  render() {
    const { selectedOptionIndices } = this.state;
    return (
      <Fragment>
        {this.state.editable ? (
          <FormControl component="fieldset">
            <FormGroup>
              {this.props.element.options.map((option, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        key={index}
                        name={option}
                        value={`${index}`}
                        onChange={() => {
                          this.onChange(option, index);
                        }}
                        checked={
                          selectedOptionIndices &&
                          !selectedOptionIndices.includes(index)
                            ? false
                            : true
                        }
                      />
                    }
                    label={option}
                  />
                );
              })}
            </FormGroup>
          </FormControl>
        ) : (
          <>
            {this.state.selectedOptions.map((option) => (
              <Typography>{option}</Typography>
            ))}
          </>
        )}
        {/* {this?.state?.helpTextValue && (
          <FormHelperText>{this.state.helpTextValue}</FormHelperText>
        )} */}
        {this.props.element.properties.allowFileUpload &&
        this.state.imageValue.length ? (
          <AiStatusOverlay
            imageList={this.state.imageValue}
            aiVerificationStatus={this.state.aiFlags.aiVerificationStatus}
            aiVerificationMessage={this.state.aiFlags.aiVerificationMessage}
          />
        ) : null}
      </Fragment>
    );
  }
}
export default CheckBox;
